import React, { useEffect, useState, useContext } from 'react';
import {
  Box,
  AppBar,
  CssBaseline,
  Toolbar,
  Button,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Link as MuiLink,
} from '@mui/material';
import {
  Menu as MenuIcon,
  ArrowDropDown as ArrowDropDownIcon,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { SocketContext } from '../../contexts/socketContext';
import {
  fetchEvents,
  fetchEventAlerts,
  fetchDetectorEvents,
} from '../../actions';
// import AlertSound from "../../res/sounds/alert.mp3";

const Header = (props) => {
  const dispatch = useDispatch();
  const socket = useContext(SocketContext);
  // const alertPlay = useRef(null);
  const { user } = useSelector((state) => state.auth);

  const [mobileOpen, setMobileOpen] = useState(false);

  const [workerAnchorEl, setWorkerAnchorEl] = useState(null);
  const [messageAnchorEl, setMessageAnchorEl] = useState(null);
  const [macroAnchorEl, setMacroAnchorEl] = useState(null);
  const [siteAnchorEl, setSiteAnchorEl] = useState(null);
  const [detectorAnchorEl, setDetectorAnchorEl] = useState(null);
  const [settingAnchorEl, setSettingAnchorEl] = useState(null);

  const openWorkers = Boolean(workerAnchorEl);
  const openMacros = Boolean(macroAnchorEl);
  const openMessages = Boolean(messageAnchorEl);
  const openSites = Boolean(siteAnchorEl);
  const openDetectors = Boolean(detectorAnchorEl);
  const openSettings = Boolean(settingAnchorEl);

  // useEffect(() => {
  //   dispatch(getLocalStorageAuth());
  // }, [dispatch]);

  useEffect(() => {
    socket.on('event_alert', ({ eventType, chipID }) => {
      console.log('event_alert', eventType, chipID);
      // alertPlay.current.muted = true;
      // alertPlay.current.play();
      // alertPlay.current.muted = false;
      dispatch(fetchEventAlerts());
      dispatch(fetchEvents());
    });
  }, [socket, dispatch]);

  const handleDrawerToggle = (event) => {
    // console.log("drawer toggle");
    setMobileOpen(!mobileOpen);
  };

  const handleWorkerClick = (event) => {
    setWorkerAnchorEl(event.currentTarget);
  };

  const handleWorkerClose = () => {
    setWorkerAnchorEl(null);
  };

  const handleMessageClick = (event) => {
    setMessageAnchorEl(event.currentTarget);
  };

  const handleMessageClose = () => {
    setMessageAnchorEl(null);
  };

  const handleMacroClick = (event) => {
    setMacroAnchorEl(event.currentTarget);
  };

  const handleMacroClose = () => {
    setMacroAnchorEl(null);
  };

  const handleSiteClick = (event) => {
    setSiteAnchorEl(event.currentTarget);
  };

  const handleSiteClose = () => {
    setSiteAnchorEl(null);
  };

  const handleDetectorClick = (event) => {
    setDetectorAnchorEl(event.currentTarget);
  };

  const handleDetectorClose = () => {
    setDetectorAnchorEl(null);
  };

  const handleSettingClick = (event) => {
    setSettingAnchorEl(event.currentTarget);
  };

  const handleSettingClose = () => {
    setSettingAnchorEl(null);
  };

  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          // width: { sm: `calc(100% - ${drawerWidth}px)` },
          // ml: { sm: `${drawerWidth}px` },
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              flexGrow: 1,
              // display: { xs: "none", sm: "block" }
            }}
          >
            <MuiLink href="/" underline="none" sx={{ color: 'white' }}>
              건설현장 안전관리
            </MuiLink>
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Button
              id="worker-button"
              key="workers"
              aria-controls={openWorkers ? 'workers-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openWorkers ? 'true' : undefined}
              onClick={handleWorkerClick}
              sx={{ color: '#fff' }}
              endIcon={<ArrowDropDownIcon />}
            >
              작업자현황
            </Button>
            <Menu
              id="workers-menu"
              anchorEl={workerAnchorEl}
              open={openWorkers}
              onClose={handleWorkerClose}
              MenuListProps={{
                'aria-labelledby': 'workers-button',
              }}
            >
              <MenuItem
                onClick={handleWorkerClose}
                component={Link}
                to="/workers"
              >
                작업자
              </MenuItem>
              <MenuItem
                onClick={handleWorkerClose}
                component={Link}
                to="/workers/attendances"
              >
                출근부
              </MenuItem>
            </Menu>

            {process.env.NODE_ENV !== 'production' && (
              <>
                <Button
                  id="message-button"
                  key="messages"
                  aria-controls={openMessages ? 'messages-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openMessages ? 'true' : undefined}
                  onClick={handleMessageClick}
                  sx={{ color: '#fff' }}
                  endIcon={<ArrowDropDownIcon />}
                >
                  메시지
                </Button>
                <Menu
                  id="messages-menu"
                  anchorEl={messageAnchorEl}
                  open={openMessages}
                  onClose={handleMessageClose}
                  MenuListProps={{
                    'aria-labelledby': 'messages-button',
                  }}
                >
                  <MenuItem
                    onClick={handleMessageClose}
                    component={Link}
                    to="/messages"
                  >
                    메시지
                  </MenuItem>
                  <MenuItem
                    onClick={handleMessageClose}
                    component={Link}
                    to="/notices"
                  >
                    공지사항
                  </MenuItem>
                  <MenuItem
                    onClick={handleMessageClose}
                    component={Link}
                    to="/events"
                  >
                    긴급호출현황
                  </MenuItem>
                </Menu>
                <Button
                  id="macros-button"
                  key="macros"
                  aria-controls={openMacros ? 'macros-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openMacros ? 'true' : undefined}
                  onClick={handleMacroClick}
                  sx={{ color: '#fff' }}
                  endIcon={<ArrowDropDownIcon />}
                >
                  매크로
                </Button>
                <Menu
                  id="macross-menu"
                  anchorEl={macroAnchorEl}
                  open={openMacros}
                  onClose={handleMacroClose}
                  MenuListProps={{
                    'aria-labelledby': 'macros-button',
                  }}
                >
                  <MenuItem
                    onClick={handleMacroClose}
                    component={Link}
                    to="/messages/macros"
                  >
                    메시지
                  </MenuItem>
                  <MenuItem
                    onClick={handleMacroClose}
                    component={Link}
                    to="/notices/macros"
                  >
                    공지사항
                  </MenuItem>
                </Menu>
              </>
            )}

            <Button
              id="sites-button"
              key="sites"
              aria-controls={openSites ? 'sites-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openSites ? 'true' : undefined}
              onClick={handleSiteClick}
              sx={{ color: '#fff' }}
              endIcon={<ArrowDropDownIcon />}
            >
              현장관리
            </Button>
            <Menu
              id="sites-menu"
              anchorEl={siteAnchorEl}
              open={openSites}
              onClose={handleSiteClose}
              MenuListProps={{
                'aria-labelledby': 'sites-button',
              }}
            >
              <MenuItem
                onClick={handleSiteClose}
                component={Link}
                to="/organizations"
              >
                건설사
              </MenuItem>
              <MenuItem
                onClick={handleSiteClose}
                component={Link}
                to="/applications"
              >
                협력사
              </MenuItem>
              <MenuItem
                onClick={handleSiteClose}
                component={Link}
                to="/gateways"
              >
                게이트웨이
              </MenuItem>
              <MenuItem
                onClick={handleSiteClose}
                component={Link}
                to="/repeaters"
              >
                작업장(리피터)
              </MenuItem>
              <MenuItem
                onClick={handleSiteClose}
                component={Link}
                to="/communicators"
              >
                안전장비
              </MenuItem>
            </Menu>
            <Button
              id="detectors-button"
              key="detectors"
              aria-controls={openDetectors ? 'detectors-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openDetectors ? 'true' : undefined}
              onClick={handleDetectorClick}
              sx={{ color: '#fff' }}
              endIcon={<ArrowDropDownIcon />}
            >
              감지기
            </Button>
            <Menu
              id="detectors-menu"
              anchorEl={detectorAnchorEl}
              open={openDetectors}
              onClose={handleDetectorClose}
              MenuListProps={{
                'aria-labelledby': 'detectors-button',
              }}
            >
              <MenuItem
                onClick={handleDetectorClose}
                component={Link}
                to="/detectors"
              >
                관리
              </MenuItem>
              <MenuItem
                onClick={handleDetectorClose}
                component={Link}
                to="/detectors/events"
              >
                모니터
              </MenuItem>
            </Menu>
            {user.type === 3 && (
              <>
                <Button
                  id="settings-button"
                  key="settings"
                  aria-controls={openSettings ? 'settings-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openSettings ? 'true' : undefined}
                  onClick={handleSettingClick}
                  sx={{ color: '#fff' }}
                  endIcon={<ArrowDropDownIcon />}
                >
                  설정
                </Button>
                <Menu
                  id="settings-menu"
                  anchorEl={settingAnchorEl}
                  open={openSettings}
                  onClose={handleSettingClose}
                  MenuListProps={{
                    'aria-labelledby': 'settings-button',
                  }}
                >
                  <MenuItem
                    onClick={handleSettingClose}
                    component={Link}
                    to="/users"
                  >
                    사용자
                  </MenuItem>
                </Menu>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      {/* <audio ref={alertPlay} src={AlertSound} /> */}
    </>
  );
};

export default Header;
